module.exports = __webpack_public_path__ + "static/media/Logo.194aaf71.svg";